export const ACTION_TOURS = {
  DETAIL: 'DETAIL',
  STATUS_ACTION: 'STATUS_ACTION'
};
